import { Response } from "express";
// import newRelic from "newrelic";

interface ApiError extends Error {
  statusCode: number;
}

// eslint-disable-next-line
function isApiError(object: any): object is ApiError {
  return "statusCode" in object;
}

export async function apiErrorHandler(
  err: ApiError | Error,
  res: Response,
  message: string
): Promise<void> {
  if (isApiError(err) && err.statusCode) {
    res.status(err.statusCode).json({ error: err.message });
    return;
  }
  if (message) {
    res.status(400).json({ error: message });
  } else {
    console.log(err);

    if (process.env.DEVELOPMENT === "false") {
      const { default: newrelic } = await import("newrelic");

      newrelic.noticeError(err);
    }
    res.status(500).json({ error: err.message });
  }
}
